<template>
  <v-flex xs12 px-3 style="padding-top: 10px !important; width: 100vw;">
    <v-flex xs12>
      <v-btn @click="gotoFrontPage" style="width: 50px;" class="breadCrumb">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn @click="deSelectMode" class="breadCrumb">
        Reports
      </v-btn>
      <v-btn @click="selectFieldData" class="breadCrumb" v-if="isFieldData">
        Field data
      </v-btn>
      <v-btn @click="selectSupplier(currentSupplier)" class="breadCrumb" v-if="isFieldData && isSupplierSelected">
        {{ currentSupplier.name }}
      </v-btn>
      <v-btn @click="selectProductionStatus" class="breadCrumb breadCrumbWide" v-if="false && isProductionStatus">
        Production status
      </v-btn>
      <v-btn @click="selectLabellingReports" class="breadCrumb breadCrumbWide" v-if="isLabellingReports">
        Labelling reports
      </v-btn>
      <v-btn @click="selectDailyProduction" class="breadCrumb breadCrumbWide" v-if="isDailyProduction">
        Daily production
      </v-btn>
      <v-btn @click="selectLoadingReport" class="breadCrumb breadCrumbWide" v-if="isLoadingReport">
        Loading report
      </v-btn>
      <v-btn @click="selectDeliveryReport" class="breadCrumb breadCrumbWide" v-if="isDeliveryReport">
        Delivery report
      </v-btn>
      <div style="display: inline; float: right;">
        <v-btn @click="$refs.forecast.printFieldData()" class="btnPrintReport" style="margin-right: 30px !important;" v-if="isFieldData && $refs.forecast && $refs.forecast.isShowingFields">Print</v-btn>
        <v-btn @click="$refs.forecast.doNotShowAllFields()" class="btnToggleFilter" :disabled="!$refs.forecast.isShowingAllFields" v-if="isFieldData && $refs.forecast && $refs.forecast.isShowingFields">Selected fields</v-btn>
        <v-btn @click="$refs.forecast.doShowAllFields()" class="btnToggleFilter" :disabled="$refs.forecast.isShowingAllFields" v-if="isFieldData && $refs.forecast && $refs.forecast.isShowingFields">All fields</v-btn>

        <v-btn @click="productionStatusExcelReport" class="btnPrintReport" v-if="false && isProductionStatus && productionStatusLoaded">Excel</v-btn>
        <v-btn @click="dailyProductionPdfReport" class="btnPrintReport" v-if="isDailyProduction && dailyProductionLoaded">Print</v-btn>
        <v-btn @click="dailyProductionExcelReport" class="btnPrintReport" v-if="isDailyProduction && dailyProductionLoaded">Excel</v-btn>
        <v-btn @click="labellingReportExcelReport" class="btnPrintReport" v-if="isLabellingReports && labellingReportsLoaded">Excel</v-btn>

        <v-btn @click="loadingReportSummaryPdfReport" class="btnPrintReport" v-if="isLoadingReport && loadingReceiptsLoaded && isLoadingReportSummary">Print</v-btn>
        <v-btn @click="loadingReportExcelReport" class="btnPrintReport" v-if="isLoadingReport && loadingReceiptsLoaded && isLoadingReportPallets">Excel</v-btn>
        <v-btn @click="selectLoadingReportModeSummary" class="btnToggleFilter" :disabled="isLoadingReportSummary" style="margin-left: 25px !important;" v-if="isLoadingReport && loadingReceiptsLoaded && !showShipment">Summary</v-btn>
        <v-btn @click="selectLoadingReportModeShipments" class="btnToggleFilter" :disabled="isLoadingReportShipments" v-if="isLoadingReport && loadingReceiptsLoaded && !showShipment">Shipments</v-btn>
        <v-btn @click="selectLoadingReportModePallets" class="btnToggleFilter" :disabled="isLoadingReportPallets" v-if="isLoadingReport && loadingReceiptsLoaded && !showShipment">Pallets</v-btn>
        <v-btn @click="printDeliveryNote" class="close" style="margin-right: 25px !important;" v-if="showShipment">Print</v-btn>
        <v-btn @click="closeShipment" class="close" style="margin-right: 15px !important;" v-if="showShipment">Close</v-btn>

        <v-btn @click="deliveryReportPdfReport" class="btnPrintReport" v-if="isDeliveryReport && deliveryReportLoaded">Print</v-btn>
        <v-btn @click="deliveryReportExcelReport" class="btnPrintReport" v-if="isDeliveryReport && deliveryReportLoaded">Excel</v-btn>
      </div>
      <div style="height: 10px;"></div>
    </v-flex>
    <v-flex xs12 v-if="!isModeSelected">
      <v-flex style="width: 50%; position: absolute; top: 50%; left: 50%; transform: translateY(-50%) translateX(-50%);">
        <v-btn @click="selectFieldData" :style="'width: 100%; height: 12vh !important; font-size: 25pt !important; margin-bottom: 2vh !important;'">Field data</v-btn>
        <v-btn @click="selectProductionStatus" :style="'width: 100%; height: 12vh !important; font-size: 25pt !important; margin-bottom: 2vh !important;'" v-if="false">Production status</v-btn>
        <v-btn @click="selectLabellingReports" :style="'width: 100%; height: 12vh !important; font-size: 25pt !important; margin-bottom: 2vh !important;'">Labelling reports</v-btn>
        <v-btn @click="selectDailyProduction" :style="'width: 100%; height: 12vh !important; font-size: 25pt !important; margin-bottom: 2vh !important;'">Daily production</v-btn>
        <v-btn @click="selectLoadingReport" :style="'width: 100%; height: 12vh !important; font-size: 25pt !important; margin-bottom: 2vh !important;'">Loading report</v-btn>
        <v-btn @click="selectDeliveryReport" :style="'width: 100%; height: 12vh !important; font-size: 25pt !important; margin-bottom: 2vh !important;'">Delivery report</v-btn>
      </v-flex>
    </v-flex>

    <div class="loader" v-if="isLoading">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <Forecast ref="forecast" hide-bread-crumb hide-buttons :edit-category-families="false" @supplierSelect="forecastSupplierSelected" v-if="isFieldData"/>

    <v-container fluid py-2 px-3 v-if="false && isProductionStatus && productionStatusLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <table class="productionStatus">
            <tr>
              <th>Field</th>
              <th>Categories</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Labelled</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Planned</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Produced</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Progress</th>
            </tr>
            <tr v-for="(status, i) in productionStatus.fields" v-bind:key="status.field ? status.field.address.id : 0" :class="(i % 2 === 0 ? 'even' : 'odd')">
              <td class="main" v-if="status.field">
                <div v-if="status.field.address.name" style="font-weight: bold;">{{ status.field.address.name }}</div>
                {{ status.field.address.text }}
              </td>
              <td class="main" v-if="!status.field">
                &nbsp;
              </td>
              <td class="main">
                <table>
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.category.label }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.labelledAmount }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.plannedAmount }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.amount }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.labelledAmount > 0 ? (Math.min(100, 100 * summary.amount / summary.labelledAmount).toFixed(0) + ' %') : 'N/A' }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isLabellingReports && labellingReportsLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <v-container fluid pa-0>
            <v-layout wrap>
              <v-flex text-xs-left xs12 md2 px-2 style="padding-top: 3px;">
                <v-text-field v-model="search" append-icon="search" placeholder="Search" style="padding-bottom: 0 !important;" class="search"/>
              </v-flex>
              <v-flex text-xs-left xs12 md3 px-2 style="padding-top: 6px;">
                <v-select :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object class="supplierFilter"/>
              </v-flex>
              <v-flex text-xs-left xs12 md3 px-2 style="padding-top: 6px;">
                <v-select :items="filterFields" v-model="filterField" item-text="displayName" prepend-icon="a-address" return-object class="fieldFilter"/>
              </v-flex>
              <v-flex text-xs-left xs12 md4 px-3 style="padding-top: 6px;">
                <v-autocomplete :items="filterCategories" v-model="filterCategory" item-text="displayLabel" prepend-icon="a-trees" return-object class="categoryFilter">
                  <template slot="selection" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex text-xs-left xs12 style="padding-top: 12px;">
                <table class="labellingReports">
                  <tr>
                    <th colspan="2">Category</th>
                    <th>Supplier</th>
                    <th>Field</th>
                    <th style="text-align: right;">Amount</th>
                  </tr>
                  <tr v-for="(report, i) in filteredLabellingReports" v-bind:key="report.id" :class="(i % 2 === 0 ? 'even' : 'odd')">
                    <td class="text-xs-left" style="width: 20px; padding: 2px 0 0 8px !important;">
                      <div v-if="report.category && report.category.color && !(report.category.color.secondColor && report.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + report.category.color.color + ';'"></div>
                      <div v-if="report.category && report.category.color && report.category.color.secondColor && report.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + report.category.color.color + ', #' + report.category.color.color + ' 3px, #' + report.category.color.secondColor + ' 3px, #' + report.category.color.secondColor + ' 6px);'"></div>
                    </td>
                    <td class="main">
                      <div v-if="report.category" v-html="report.category.label" style="display: inline-flex; padding-right: 12px;"></div>
                      <v-icon v-if="report.category && report.category.image" class="tag" @click="showCategoryImage(report.category.image)">fa-tag</v-icon>
                    </td>
                    <td class="main"><div v-if="report.supplier" v-html="report.supplier.name"></div></td>
                    <td class="main">
                      <div v-if="report.field">{{ getFieldName(report.field) }}</div>
                    </td>
                    <td class="main" style="text-align: right; padding-right: 8px;"><div v-html="report.total"></div></td>
                  </tr>
                  <tr>
                    <td class="main" colspan="4" style="padding: 8px; font-weight: bold">Total</td>
                    <td class="main total" style="text-align: right; padding: 8px; font-weight: bold"><div v-html="totalLabellingReportAmount"></div></td>
                  </tr>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isDailyProduction && dailyProductionLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <v-container fluid pa-0>
            <v-layout wrap>
              <v-flex text-xs-left xs12 md2 px-2 style="padding-top: 6px;">
                <v-select :items="filterProducedByValues" v-model="filterProducedBy" multiple item-text="name" prepend-icon="fa-user" return-object class="producedByFilter"/>
              </v-flex>
              <v-flex text-xs-left xs12 md3 px-2 style="padding-top: 6px;">
                <v-select :items="filterSuppliers" v-model="filterSupplier" item-text="name" prepend-icon="a-factory" return-object class="supplierFilter"/>
              </v-flex>
              <v-flex text-xs-left xs12 md4 px-2 style="padding-top: 6px;">
                <v-select :items="filterFields" v-model="filterField" item-text="displayName" prepend-icon="a-address" return-object class="fieldFilter"/>
              </v-flex>
              <v-flex text-xs-left xs12 md3 px-3 style="padding-top: 6px;">
                <v-autocomplete :items="filterCategories" v-model="filterCategory" item-text="displayLabel" prepend-icon="a-trees" return-object class="categoryFilter">
                  <template slot="selection" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <div v-if="data.item.color && !(data.item.color.secondColor && data.item.color.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color.color + ';'"></div>
                    <div v-if="data.item.color && data.item.color.secondColor && data.item.color.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color.color + ', #' + data.item.color.color + ' 3px, #' + data.item.color.secondColor + ' 3px, #' + data.item.color.secondColor + ' 6px);'"></div>
                    {{ data.item.displayLabel }}
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex text-xs-left xs12 style="padding-top: 12px;">
                <table class="productionReport">
                  <tr>
                    <th>Produced</th>
                    <th>By</th>
                    <th>Shipment</th>
                    <th>Pallet</th>
                    <th>Category</th>
                    <th style="text-align: right;">Amount</th>
                    <th>Supplier</th>
                    <th>Field</th>
                  </tr>
                  <template v-for="(report, i) in filteredDailyProduction.dates">
                    <tr v-for="(line) in report.lines" v-bind:key="line.key" :class="(report.rowIndex % 2 === 0 ? 'evenByDate' : 'oddByDate') + (report.firstInRow && line.lineIndex === 0 ? ' dateChanged' : '')">
                      <td class="main">{{ report.date !== '0000-00-00 00:00' && report.date !== '9999-12-31 23:59' ? report.date : '' }}</td>
                      <td class="main">{{ line.producedBy ? line.producedBy : '' }}</td>
                      <td class="main">{{ line.shipmentNumber }}</td>
                      <td class="main">{{ line.palletNumber }}</td>
                      <td class="main"><div v-html="line.categories"></div></td>
                      <td class="main" style="text-align: right; padding-right: 8px;"><div v-html="line.totalAmount"></div></td>
                      <td class="main">{{ line.supplier.name }}</td>
                      <td class="main">{{ line.field ? line.field.address && line.field.address.name && line.field.address.name !== '' ? line.field.address.name : line.field.address ? line.field.address.text : '' : ''}}</td>
                    </tr>
                    <tr v-if="report.type === 'total'" :class="(report.rowIndex % 2 === 0 ? 'evenByDate' : 'oddByDate')" style="border-bottom: 2px solid #303030;" :key="'total_' + i">
                      <td class="subTotal" colspan="5">Total</td>
                      <td class="subTotal" style="text-align: right; padding-right: 8px;">{{ report.amount }}</td>
                      <td class="subTotal" colspan="2"></td>
                    </tr>
                  </template>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isLoadingReport && loadingReceiptsLoaded && !showShipment">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <table style="min-width: 500px; border-collapse: collapse;" class="loadingReceipts" v-if="isLoadingReportSummary">
            <template v-for="(summary, i) in loadingReportSummary">
              <tr :key="'lrs_' + i">
                <th colspan="3" style="padding-top: 20px;">{{ summary.supplierName }}</th>
              </tr>
              <tr v-for="(item, j) in summary.items" :key="'lrsi_' + i + '_' + j" :class="(j % 2 === 0 ? 'even' : 'odd')">
                <td class="text-xs-left" style="width: 20px; padding: 2px 0 0 8px;">
                  <div v-if="item.category && item.category.color && !(item.category.color.secondColor && item.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + item.category.color.color + ';'"></div>
                  <div v-if="item.category && item.category.color && item.category.color.secondColor && item.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + item.category.color.color + ', #' + item.category.color.color + ' 3px, #' + item.category.color.secondColor + ' 3px, #' + item.category.color.secondColor + ' 6px);'"></div>
                </td>
                <td>{{ item.category.displayLabel }}</td>
                <td style="text-align: right; padding-right: 10px;">{{ item.amount }}</td>
              </tr>
            </template>
          </table>
          <table class="loadingReceipts" v-if="isLoadingReportShipments">
            <tr>
              <th style="width: 150px;">Loaded</th>
              <th style="width: 150px;">Shipment</th>
              <th style="width: 150px;">License plate(s)</th>
              <th>Loading address</th>
              <th style="width: 150px;">Internal transport</th>
            </tr>
            <tr v-for="(shipmentLoaded, i) in shipmentsLoaded" v-bind:key="shipmentLoaded.shipment.id" @click="selectShipment(shipmentLoaded)" :class="'selectable ' + (i % 2 === 0 ? 'even' : 'odd')">
              <td class="main" style="white-space: nowrap;">{{ shipmentLoaded.timestamp }}</td>
              <td class="main">{{ shipmentLoaded.shipment ? shipmentLoaded.shipment.number : '' }}</td>
              <td class="main" style="white-space: nowrap;">{{ shipmentLoaded.shipment ? shipmentLoaded.shipment.licensePlate : '' }}</td>
              <td class="main">{{ shipmentLoaded.address && shipmentLoaded.address.name && shipmentLoaded.address.name !== '' ? shipmentLoaded.address.name : shipmentLoaded.address ? shipmentLoaded.address.text : '' }}</td>
              <td class="main">{{ shipmentLoaded.internalTransport ? 'Yes' : 'No' }}</td>
            </tr>
          </table>
          <table class="loadingReceipts" v-if="isLoadingReportPallets">
            <tr>
              <th style="width: 150px;">Loaded</th>
              <th style="width: 50px;">By</th>
              <th style="width: 100px;">Pallet</th>
              <th>Supplier</th>
              <th>Shipment</th>
              <th>License plate(s)</th>
              <th>Category</th>
              <th style="width: 50px; padding-right: 20px;">Amount</th>
              <th>Loading address</th>
              <th style="width: 150px;">Internal transport</th>
            </tr>
            <tr v-for="(receipt, i) in loadingReceipts" v-bind:key="receipt.id" :class="(i % 2 === 0 ? 'even' : 'odd')">
              <td class="main" style="white-space: nowrap;">{{ receipt.timestamp }}</td>
              <td class="main" style="white-space: nowrap;">{{ receipt.userFullName }}</td>
              <td class="main">{{ receipt.pallet.palletNumber }}</td>
              <td class="main" style="white-space: nowrap;">{{ receipt.supplier.name }}</td>
              <td class="main">{{ receipt.shipment ? receipt.shipment.number : '' }}</td>
              <td class="main" style="white-space: nowrap;">{{ receipt.shipment ? receipt.shipment.licensePlate : '' }}</td>
              <td class="main" style="white-space: nowrap;">
                <div v-for="(category, c) in receipt.categories" v-bind:key="c">{{ category }}</div>
              </td>
              <td class="main" style="text-align: right; white-space: nowrap; padding-right: 20px;">
                <div v-for="(amount, a) in receipt.amounts" v-bind:key="a">{{ amount }}</div>
              </td>
              <td class="main">{{ receipt.address && receipt.address.name && receipt.address.name !== '' ? receipt.address.name : receipt.address ? receipt.address.text : '' }}</td>
              <td class="main">{{ receipt.internalTransport ? 'Yes' : 'No' }}</td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid pa-0 v-show="showShipment" class="shipmentContainer">
      <v-layout style="max-height: calc(100vh - 160px);">
        <v-flex style="overflow-y: auto;">
          <Panel :title="'Shipment #' + currentShipment.number" v-if="showShipment" class="shipmentPanel">
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport">
              <v-label>Carrier</v-label>
            </v-flex>
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport">
              {{ currentShipment.carrierName }}
            </v-flex>
            <v-flex xs12 sm4 v-if="!currentShipment.internalTransport"/>
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport">
              <v-label>Loading date</v-label>
            </v-flex>
            <v-flex xs12 sm2 v-if="!currentShipment.internalTransport">
              {{ currentShipment.pickupDate }}
            </v-flex>
            <v-flex xs12 sm2>
              <v-label>License plate(s)</v-label>
            </v-flex>
            <v-flex xs12 sm4>
              {{ currentShipment.licensePlate }}
            </v-flex>
            <v-flex xs12 sm6 v-if="showShipmentComment">
              <div style="white-space: pre-wrap;">{{ currentShipment.comment }}</div>
            </v-flex>
            <v-flex xs12 style="height: 10px;"/>
            <v-flex xs12 v-if="palletOrders && palletOrders.length > 0" class="truckContainer" style="overflow-x: scroll;">
              <table style="min-width: 100%;">
                <tr style="height: 400px;">
                  <td>
                    <table class="palletPosition truck" v-if="showTruck">
                      <tr>
                        <td rowspan="4" class="front"></td>
                        <td colspan="5" style="height: 22px; background: transparent;"></td>
                      </tr>
                      <tr class="rightSide">
                        <LoaderPallet number="1" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true" style="border-top-left-radius: 8px;"/>
                        <LoaderPallet number="3" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="5" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="7" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="9" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true" style="border-top-right-radius: 8px;"/>
                      </tr>
                      <tr class="leftSide">
                        <LoaderPallet number="2" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true" style="border-bottom-left-radius: 8px;"/>
                        <LoaderPallet number="4" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="6" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="8" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true"/>
                        <LoaderPallet number="10" :palletPositions="palletPositions" :currentShipment="currentShipment" :pallet-orders="palletOrders" :disabled="true" style="border-bottom-right-radius: 8px;"/>
                      </tr>
                      <tr>
                        <td colspan="5" style="height: 22px; background: transparent;"></td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </v-flex>
          </Panel>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isDeliveryReport && deliveryReportLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
          <v-data-table :headers="deliveryReportHeaders" :items="deliveryReport.items" hide-actions class="deliveryReportTable">
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left" style="width: 20px; padding-left: 8px !important; padding-right: 0 !important; padding-top: 4px !important; padding-bottom: 0 !important;">
                  <div v-if="props.item.category && props.item.category.color && !(props.item.category.color.secondColor && props.item.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + props.item.category.color.color + ';'"></div>
                  <div v-if="props.item.category && props.item.category.color && props.item.category.color.secondColor && props.item.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + props.item.category.color.color + ', #' + props.item.category.color.color + ' 3px, #' + props.item.category.color.secondColor + ' 3px, #' + props.item.category.color.secondColor + ' 6px);'"></div>
                  <div v-if="!props.item.category">&nbsp;</div>
                </td>
                <td class="text-xs-left" style="padding-top: 4px !important;">
                  <div v-if="props.item.category">{{ props.item.category.displayLabel }}</div>
                  <div v-if="!props.item.category" style="font-weight: bold;">Total</div>
                </td>
                <td class="text-xs-right" style="padding-top: 4px !important;">
                  <div :style="props.item.category ? '' : 'font-weight: bold;'">{{ props.item.amount.toLocaleString() }}</div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
    <div style="background-color: rgba(0, 0, 0, 0.25); position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;" @click="showCategoryImageDialog = false" v-if="showCategoryImageDialog">
      <img :src="categoryImageUrl" style="max-width: 80%; max-height: 80%; border: 5px solid white; border-radius: 5px;"/>
    </div>

    <ErrorDialog ref="errorDialog"/>
  </v-flex>
</template>

<script>
import Panel from '../components/Panel'
import LoaderPallet from '../components/LoaderPallet'
import PalletItems from '../components/PalletItems'
import PanelColumn from '../components/PanelColumn'
import ErrorDialog from '../components/ErrorDialog'
import Forecast from '../components/Forecast'
import DateUtil from '@/assets/javascript/dateutil'
import axios from 'axios'
import uuid from 'uuid/v4'

export default {
  name: 'Reports',
  components: { Panel, LoaderPallet, PanelColumn, ErrorDialog, Forecast, PalletItems },
  data () {
    return {
      productionStatus: [],
      productionStatusLoaded: false,
      labellingReports: null,
      labellingReportsLoaded: false,
      loadingReceipts: null,
      loadingReceiptsLoaded: false,
      loadingReportMode: 'SHIPMENTS',
      currentShipment: null,
      palletOrders: [],
      pallets: [],
      palletPositions: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
      ],
      showTruck: false,
      dailyProduction: null,
      dailyProductionLoaded: false,
      deliveryReport: null,
      deliveryReportLoaded: false,
      mode: null,
      deliveryReportHeaders: [
        { text: '', sortable: false },
        { text: 'Category', value: 'category.displayLabel', sortable: false },
        { text: 'Amount', value: 'amount', sortable: false, align: 'right' }
      ],
      currentSupplier: null,
      search: '',
      filterSuppliers: [],
      filterSupplier: { id: 0 },
      filterFields: [],
      filterField: { id: 0 },
      filterCategories: [],
      filterCategory: { id: 0 },
      filterProducedByValues: [],
      filterProducedBy: [],
      showCategoryImageDialog: false,
      categoryImageUrl: ''
    }
  },
  created: function () {
    this.deSelectMode()
  },
  computed: {
    hasForecastRole: function () {
      return this.$store.getters['session/hasRole']('FORECAST')
    },
    isSupplierSelected: function () {
      return this.currentSupplier
    },
    isModeSelected: function () {
      return this.mode !== null
    },
    isFieldData: function () {
      return this.mode === 'FIELD_DATA'
    },
    isProductionStatus: function () {
      return this.mode === 'PRODUCTION_STATUS'
    },
    isDailyProduction: function () {
      return this.mode === 'DAILY_PRODUCTION'
    },
    isLabellingReports: function () {
      return this.mode === 'LABELLING_REPORTS'
    },
    isLoadingReport: function () {
      return this.mode === 'LOADING_REPORT'
    },
    isLoadingReportSummary: function () {
      return this.loadingReportMode === 'SUMMARY'
    },
    isLoadingReportShipments: function () {
      return this.loadingReportMode === 'SHIPMENTS'
    },
    isLoadingReportPallets: function () {
      return this.loadingReportMode === 'PALLETS'
    },
    isDeliveryReport: function () {
      return this.mode === 'DELIVERY_REPORT'
    },
    isLoading: function () {
      if (this.isModeSelected) {
        if (this.isLoadingReport) {
          return !this.loadingReceiptsLoaded
        } else if (this.isDeliveryReport) {
          return !this.deliveryReportLoaded
        } else if (this.isDailyProduction) {
          return !this.dailyProductionLoaded
        } else if (this.isLabellingReports) {
          return !this.labellingReportsLoaded
        }
      }
      return false
    },
    loadingReportSummary: function () {
      let suppliers = []
      if (this.loadingReceipts && this.loadingReceipts.length) {
        for (let loadingReceipt of this.loadingReceipts) {
          if (loadingReceipt.supplier && loadingReceipt.supplier.id && !suppliers.filter(s => s.id === loadingReceipt.supplier.id).length) {
            suppliers.push(loadingReceipt.supplier)
          }
        }
      }
      suppliers.sort((a, b) => a.name.localeCompare(b.name))

      let summary = []
      for (let supplier of suppliers) {
        let supplierSummary = {
          supplierId: supplier.id,
          supplierName: supplier.name,
          items: []
        }

        let categories = []
        for (let loadingReceipt of this.loadingReceipts) {
          if (loadingReceipt.supplier && loadingReceipt.supplier.id === supplier.id && loadingReceipt.pallet && loadingReceipt.pallet.items && loadingReceipt.pallet.items.length) {
            for (let item of loadingReceipt.pallet.items) {
              if (!categories.filter(c => c.id === item.category.id).length) {
                categories.push(item.category)
              }
            }
          }
        }
        categories.sort((a, b) => a.sortableLabel.localeCompare(b.sortableLabel))

        for (let category of categories) {
          let totalAmount = 0
          for (let loadingReceipt of this.loadingReceipts) {
            if (loadingReceipt.supplier && loadingReceipt.supplier.id === supplier.id && loadingReceipt.pallet && loadingReceipt.pallet.items && loadingReceipt.pallet.items.length) {
              for (let item of loadingReceipt.pallet.items) {
                if (item.category.id === category.id && item.amount) {
                  totalAmount += item.amount
                }
              }
            }
          }

          supplierSummary.items.push({
            category: category,
            amount: totalAmount
          })
        }

        summary.push(supplierSummary)
      }
      return summary
    },
    shipmentsLoaded: function () {
      let shipments = []
      if (this.loadingReceipts && this.loadingReceipts.length) {
        for (let loadingReceipt of this.loadingReceipts) {
          if (loadingReceipt.shipment && !shipments.filter(s => s.shipment.id === loadingReceipt.shipment.id).length) {
            let shipment = {
              timestamp: loadingReceipt.timestamp,
              shipment: loadingReceipt.shipment,
              address: loadingReceipt.address,
              internalTransport: loadingReceipt.internalTransport
            }
            shipments.push(shipment)
          }
        }
      }
      return shipments
    },
    showShipment: function () {
      return this.currentShipment !== null
    },
    showShipmentComment: function () {
      return this.currentShipment && this.currentShipment.comment
    },
    filteredLabellingReports: function () {
      if (!this.labellingReports || !this.labellingReports.length) {
        return []
      }
      let filteredLabellingReports = []
      for (let labellingReport of this.labellingReports) {
        if (this.search && this.search !== '') {
          let search = this.search.toLowerCase()
          let category = labellingReport.category && labellingReport.category.label ? labellingReport.category.label.toLowerCase() : ''
          let supplier = labellingReport.supplier && labellingReport.supplier.name ? labellingReport.supplier.name.toLowerCase() : ''
          let field = labellingReport.field.address && labellingReport.field.address.name && labellingReport.field.address.name !== '' ? labellingReport.field.address.name.toLowerCase() : labellingReport.field.address.toLowerCase() ? labellingReport.field.address.text.toLowerCase() : ''
          if (!category.includes(search) && !supplier.includes(search) && !field.includes(search)) {
            continue
          }
        }
        if (this.filterSupplier && this.filterSupplier.id) {
          if (labellingReport.supplier && labellingReport.supplier.id !== this.filterSupplier.id) {
            continue
          }
        }
        if (this.filterField && this.filterField.id) {
          if (labellingReport.field && labellingReport.field.id !== this.filterField.id) {
            continue
          }
        }
        if (this.filterCategory && this.filterCategory.id) {
          if (labellingReport.category && labellingReport.category.id !== this.filterCategory.id) {
            continue
          }
        }
        filteredLabellingReports.push(labellingReport)
      }
      return filteredLabellingReports
    },
    totalLabellingReportAmount: function () {
      let totalAmount = 0
      for (let labellingReport of this.filteredLabellingReports) {
        totalAmount += labellingReport.total
      }
      return totalAmount
    },
    filteredDailyProduction: function () {
      let dates = []
      for (let date of this.dailyProduction.dates) {
        let d = {
          date: date.date,
          lines: [],
          firstInRow: false,
          rowIndex: 0
        }

        for (let line of date.lines) {
          if (this.filterProducedBy && this.filterProducedBy.length) {
            if (!this.filterProducedBy.filter(pb => pb.id === line.producedById).length) {
              continue
            }
          }
          if (this.filterSupplier && this.filterSupplier.id) {
            if (!(line.supplier && line.supplier.id === this.filterSupplier.id)) {
              continue
            }
          }
          if (this.filterField && this.filterField.id) {
            if (!(line.field && line.field.id === this.filterField.id)) {
              continue
            }
          }
          if (this.filterCategory && this.filterCategory.id) {
            if (!(line.categorySet && line.categorySet.length && line.categorySet.filter(c => c.id === this.filterCategory.id).length)) {
              continue
            }
          }
          d.lines.push(line)
        }

        if (d.lines.length) {
          dates.push(d)
        }
      }

      let lastDate = ''
      let rowIndex = 1
      for (let date of dates) {
        let d = date.date.substring(0, 'yyyy-MM-dd'.length)
        if (d !== lastDate) {
          date.firstInRow = true
          rowIndex = !rowIndex
        }
        date.rowIndex = rowIndex
        lastDate = d
      }

      // Insert sum rows
      let finalDates = []
      let lastRowIndex = 0
      let lastLineIndex = 0
      let lastDay = ''
      let totalAmount = 0
      for (let date of dates) {
        let currentDay = date.date.substring(0, 'yyyy-MM-dd'.length)
        if (lastDay !== '' && lastDay !== currentDay) {
          finalDates.push({
            type: 'total',
            amount: totalAmount,
            rowIndex: lastRowIndex,
            lineIndex: lastLineIndex,
            firstInRow: false,
            lines: []
          })
          totalAmount = 0
        }
        if (date.lines && date.lines.length) {
          for (let line of date.lines) {
            if (line.totalAmount && line.totalAmountNumber) {
              totalAmount += line.totalAmountNumber
            }
          }
        }
        finalDates.push(date)
        lastDay = currentDay
        lastRowIndex = date.rowIndex
        lastLineIndex = date.lineIndex
      }
      if (totalAmount > 0) {
        finalDates.push({
          type: 'total',
          amount: totalAmount,
          rowIndex: lastRowIndex,
          lineIndex: lastLineIndex,
          firstInRow: false,
          lines: []
        })
      }

      let dailyProduction = {
        categories: [],
        dates: finalDates
      }

      return dailyProduction
    }
  },
  methods: {
    gotoFrontPage: function () {
      this.$parent.$parent.gotoHome()
    },
    deSelectMode () {
      this.mode = null
      this.currentShipment = null
      this.showTruck = false
    },
    selectFieldData () {
      this.mode = 'FIELD_DATA'
      this.loadFieldData()
    },
    selectSupplier () {
      if (this.isFieldData) {
        this.$refs.forecast.selectSupplier(this.currentSupplier)
      }
    },
    selectProductionStatus () {
      this.mode = 'PRODUCTION_STATUS'
      this.loadProductionStatus()
    },
    selectDailyProduction () {
      this.mode = 'DAILY_PRODUCTION'
      this.loadDailyProduction()
    },
    selectLabellingReports () {
      this.mode = 'LABELLING_REPORTS'
      this.loadLabellingReports()
    },
    selectLoadingReport () {
      this.mode = 'LOADING_REPORT'
      this.currentShipment = null
      this.selectLoadingReportModeSummary()
      this.loadLoadingReceipts()
    },
    selectLoadingReportModeSummary () {
      this.loadingReportMode = 'SUMMARY'
    },
    selectLoadingReportModeShipments () {
      this.loadingReportMode = 'SHIPMENTS'
    },
    selectLoadingReportModePallets () {
      this.loadingReportMode = 'PALLETS'
    },
    selectDeliveryReport () {
      this.mode = 'DELIVERY_REPORT'
      this.loadDeliveryReport()
    },
    loadFieldData () {
      this.currentSupplier = null
      this.$nextTick(() => {
        this.$refs.forecast.gotoForecast()
      })
    },
    loadProductionStatus () {
      this.productionStatus = []
      this.productionStatusLoaded = false
      axios.get('/backend/rest/production_status')
        .then(response => {
          this.productionStatus = response.data
          this.productionStatusLoaded = true
        })
    },
    loadDailyProduction () {
      this.dailyProductionLoaded = false
      axios.get('/backend/rest/production_report/supplier')
        .then(response => {
          this.dailyProduction = response.data
          this.dailyProductionLoaded = true
          this.initProducedByForDailyProduction(this.dailyProduction)
          this.initSuppliersForDailyProduction(this.dailyProduction)
          this.initFieldsForDailyProduction(this.dailyProduction)
          this.initCategoriesForDailyProduction(this.dailyProduction)
        })
    },
    loadLabellingReports () {
      this.labellingReportsLoaded = false
      axios.get('/backend/rest/label_report/supplier')
        .then(response => {
          this.labellingReports = response.data
          this.labellingReportsLoaded = true
          this.initSuppliersForLabellingReports(this.labellingReports)
          this.initFieldsForLabellingReports(this.labellingReports)
          this.initCategoriesForLabellingReports(this.labellingReports)
        })
    },
    initProducedByForDailyProduction (dailyProduction) {
      let producedBy = []
      if (dailyProduction && dailyProduction.dates && dailyProduction.dates.length) {
        for (let date of dailyProduction.dates) {
          if (date.lines && date.lines.length) {
            for (let line of date.lines) {
              if (line.producedById && line.producedBy && line.producedBy !== '' && !producedBy.filter(pb => pb.id === line.producedById).length) {
                producedBy.push({
                  id: line.producedById,
                  name: line.producedBy
                })
              }
            }
          }
        }
      }
      producedBy.sort(function (f1, f2) {
        return f1.name.toLowerCase().localeCompare(f2.name.toLowerCase())
      })
      this.filterProducedByValues = JSON.parse(JSON.stringify(producedBy))
    },
    initSuppliersForDailyProduction (dailyProduction) {
      let suppliers = []
      if (dailyProduction && dailyProduction.dates && dailyProduction.dates.length) {
        for (let date of dailyProduction.dates) {
          if (date.lines && date.lines.length) {
            for (let line of date.lines) {
              if (line.supplier && !suppliers.filter(s => s.id === line.supplier.id).length) {
                suppliers.push(line.supplier)
              }
            }
          }
        }
      }
      this.filterSuppliers = JSON.parse(JSON.stringify(suppliers))
      this.filterSuppliers.splice(0, 0, {
        id: 0,
        name: ''
      })
      this.filterSuppliers.sort(function (f1, f2) {
        return f1.name.toLowerCase().localeCompare(f2.name.toLowerCase())
      })
    },
    initSuppliersForLabellingReports (labellingReports) {
      let suppliers = []
      if (labellingReports && labellingReports.length) {
        for (let labellingReport of labellingReports) {
          if (suppliers.filter(s => s.id === labellingReport.supplier.id).length === 0) {
            suppliers.push(labellingReport.supplier)
          }
        }
      }
      this.filterSuppliers = JSON.parse(JSON.stringify(suppliers))
      this.filterSuppliers.splice(0, 0, {
        id: 0,
        name: ''
      })
      this.filterSuppliers.sort(function (f1, f2) {
        return f1.name.toLowerCase().localeCompare(f2.name.toLowerCase())
      })
    },
    initFieldsForDailyProduction (dailyProduction) {
      let fields = []
      if (dailyProduction && dailyProduction.dates && dailyProduction.dates.length) {
        for (let date of dailyProduction.dates) {
          if (date.lines && date.lines.length) {
            for (let line of date.lines) {
              if (line.field && !fields.filter(f => f.id === line.field.id).length) {
                let field = JSON.parse(JSON.stringify(line.field))
                field.displayName = this.getFieldName(field)
                fields.push(field)
              }
            }
          }
        }
      }
      this.filterFields = JSON.parse(JSON.stringify(fields))
      this.filterFields.splice(0, 0, {
        id: 0,
        displayName: ''
      })
      this.filterFields.sort(function (f1, f2) {
        return f1.displayName.toLowerCase().localeCompare(f2.displayName.toLowerCase())
      })
    },
    initFieldsForLabellingReports (labellingReports) {
      let fields = []
      if (labellingReports && labellingReports.length) {
        for (let labellingReport of labellingReports) {
          if (fields.filter(f => f.id === labellingReport.field.id).length === 0) {
            let field = JSON.parse(JSON.stringify(labellingReport.field))
            field.displayName = this.getFieldName(field)
            fields.push(field)
          }
        }
      }
      this.filterFields = JSON.parse(JSON.stringify(fields))
      this.filterFields.splice(0, 0, {
        id: 0,
        displayName: ''
      })
      this.filterFields.sort(function (f1, f2) {
        return f1.displayName.toLowerCase().localeCompare(f2.displayName.toLowerCase())
      })
    },
    initCategoriesForDailyProduction (dailyProduction) {
      this.filterCategories = []
      if (dailyProduction.categories && dailyProduction.categories.length) {
        for (let category of dailyProduction.categories) {
          if (!this.filterCategories.filter(c => c.id === category.id).length) {
            this.filterCategories.push(category)
          }
        }
      }
      this.filterCategories.splice(0, 0, {
        id: 0,
        displayLabel: '',
        sortableLabel: ''
      })
      this.filterCategories.sort(function (f1, f2) {
        return f1.sortableLabel.localeCompare(f2.sortableLabel)
      })
    },
    initCategoriesForLabellingReports (labellingReports) {
      this.filterCategories = []
      if (labellingReports && labellingReports.length) {
        for (let labellingReport of labellingReports) {
          if (labellingReport.category && this.filterCategories.filter(c => c.id === labellingReport.category.id).length === 0) {
            this.filterCategories.push(labellingReport.category)
          }
        }
      }
      this.filterCategories.splice(0, 0, {
        id: 0,
        displayLabel: '',
        sortableLabel: ''
      })
      this.filterCategories.sort(function (f1, f2) {
        return f1.sortableLabel.localeCompare(f2.sortableLabel)
      })
    },
    loadLoadingReceipts () {
      this.loadingReceiptsLoaded = false
      axios.get('/backend/rest/pallet_loading_receipt/supplier')
        .then(response => {
          this.loadingReceipts = response.data
          this.loadingReceiptsLoaded = true
        })
    },
    loadDeliveryReport () {
      this.deliveryReportLoaded = false
      axios.get('/backend/rest/delivery_report')
        .then(response => {
          this.deliveryReport = response.data
          if (this.deliveryReport && this.deliveryReport.items) {
            let total = 0
            for (let item of this.deliveryReport.items) {
              total += item.amount
            }
            this.deliveryReport.items.push({
              category: null,
              amount: total
            })
          }
          this.deliveryReportLoaded = true
        })
    },
    getFieldName (field) {
      return field.address && field.address.name && field.address.name !== '' ? field.address.name : field.address ? field.address.text : ''
    },
    selectShipment: function (shipmentLoaded) {
      this.showTruck = true
      this.loadShipment(shipmentLoaded.shipment.id)
    },
    closeShipment: function () {
      this.currentShipment = null
    },
    printDeliveryNote: function () {
      let url = '/backend/print/deliveryNote.xhtml?shipmentId=' + this.currentShipment.id + '&details=true&title=Delivery Note'
      window.open(url)
    },
    loadShipment (shipmentId) {
      // console.log('Loading shipment')
      axios.get('/backend/rest/shipment/loader/' + shipmentId)
        .then(response => {
          this.currentShipment = response.data
          this.loadPalletsForShipment()
        })
    },
    loadPalletsForShipment () {
      this.palletOrders = []
      this.pallets = []
      this.palletPositions = [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
      ]
      if (this.currentShipment) {
        // console.log('Loading pallet orders for shipment ' + this.currentShipment.id)
        let url = '/backend/rest/pallet_order/shipment/' + this.currentShipment.id
        axios.get(url)
          .then(response => {
            // console.log('Pallets: ' + JSON.stringify(response.data))
            this.palletOrders = response.data

            if (this.palletOrders && this.palletOrders.length > 0) {
              for (let palletOrder of this.palletOrders) {
                // console.log('Set pallet on position ' + (pallet.position - 1))
                this.$set(this.palletPositions, palletOrder.position - 1, palletOrder)
              }
            } else if (this.currentShipment.internalTransport) {
              this.palletOrders = []

              // Create dummy pallet orders
              for (let i = 0; i < 10; i++) {
                let palletOrder = {
                  id: -i - 1
                }
                this.palletOrders.push(palletOrder)
                this.$set(this.palletPositions, i, palletOrder)
              }
            }

            axios.get('/backend/rest/pallet/shipment/' + this.currentShipment.id)
              .then(response => {
                // console.log('Pallets: ' + JSON.stringify(response.data))
                this.pallets = response.data

                if (this.pallets && this.pallets.length > 0) {
                  for (let pallet of this.pallets) {
                    // console.log('Set pallet on position ' + (pallet.position - 1))
                    let position = this.currentShipment && pallet.internalTransportPosition ? pallet.internalTransportPosition : pallet.position
                    this.$set(this.palletPositions, position - 1, pallet)
                  }
                }
              })
          })
      }
    },
    formatDatetime (date) {
      return DateUtil.datetimeToString(date)
    },
    categories: function (pallet) {
      let categories = ''
      if (pallet.items) {
        let items = pallet.items
        for (let item of items) {
          if (categories.length > 0) {
            categories += '<br/>'
          }
          categories += (item.category ? item.category.label : item.categoryName)
          categories += ', ' + item.plannedAmount + 'pcs.'
        }
      }
      return categories
    },
    productionStatusExcelReport () {
      let url = '/backend/report/supplierStatus&uuid=' + uuid()
      window.open(url)
    },
    dailyProductionPdfReport () {
      let parameters = 'uuid=' + uuid()
      if (this.filterProducedBy && this.filterProducedBy.length) {
        parameters += '&producedBy=' + this.filterProducedBy.map(pb => pb.id).join(',')
      }
      if (this.filterSupplier && this.filterSupplier.id) {
        parameters += '&suppliers=' + this.filterSupplier.id
      }
      if (this.filterField && this.filterField.id) {
        parameters += '&fields=' + this.filterField.id
      }
      if (this.filterCategory && this.filterCategory.id) {
        parameters += '&categories=' + this.filterCategory.id
      }
      let url = '/backend/print/supplierProductionReportByDate.xhtml?' + parameters
      window.open(url)
    },
    dailyProductionExcelReport () {
      let parameters = 'uuid=' + uuid()
      if (this.filterProducedBy && this.filterProducedBy.length) {
        parameters += '&producedBy=' + this.filterProducedBy.map(pb => pb.id).join(',')
      }
      if (this.filterSupplier && this.filterSupplier.id) {
        parameters += '&suppliers=' + this.filterSupplier.id
      }
      if (this.filterField && this.filterField.id) {
        parameters += '&fields=' + this.filterField.id
      }
      if (this.filterCategory && this.filterCategory.id) {
        parameters += '&categories=' + this.filterCategory.id
      }
      let url = '/backend/report/productionReport/supplier?' + parameters
      window.open(url)
    },
    labellingReportExcelReport () {
      let labelReportIds = []
      for (let labellingReport of this.filteredLabellingReports) {
        labelReportIds.push(labellingReport.id)
      }
      let params = 'labelReports=' + labelReportIds.join(',')
      axios.post('/backend/report/labelReport/supplier', params, {responseType: 'blob'})
        .then((response) => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([response.data], { type: 'application/vnd.ms-excel' }), 'Labelling reports.xlsx')
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Labelling reports.xlsx')
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    loadingReportSummaryPdfReport: function () {
      let url = '/backend/print/supplierLoadingReportSummary.xhtml?title=Loading Report'
      window.open(url)
    },
    loadingReportExcelReport () {
      let url = '/backend/report/loadingReport/supplier&uuid=' + uuid()
      window.open(url)
    },
    deliveryReportPdfReport () {
      let url = '/backend/print/deliveryReport.xhtml?title=Delivery report&uuid=' + uuid()
      window.open(url)
    },
    deliveryReportExcelReport () {
      let url = '/backend/report/deliveryReport&uuid=' + uuid()
      window.open(url)
    },
    forecastSupplierSelected (supplier) {
      // console.log('Forecast supplier selected: ', supplier)
      this.currentSupplier = supplier
    },
    showCategoryImage: function (imageUuid) {
      this.categoryImageUrl = '/backend/image/' + imageUuid
      this.showCategoryImageDialog = true
    }
  }
}
</script>

<style scoped>
  button {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .v-btn {
    border-radius: 12px;
  }
  .v-btn .v-btn__content {
  }
  table.productionStatus {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.productionStatus th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.productionStatus td.main {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 5px;
  }
  table.productionReport {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.productionReport th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.productionReport td.main {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 5px;
  }
  table.productionReport td.subTotal {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 5px 10px 5px;
    font-weight: bold;
  }
  table.labellingReports,
  table.loadingReceipts {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.labellingReports th,
  table.loadingReceipts th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.labellingReports td,
  table.loadingReceipts td {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 5px;
  }
  tr.odd {
    background-color: #ffffff;
  }
  tr.even {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.oddByDate {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.evenByDate {
    background-color: #ffffff;
  }
  tr.dateChanged {
    border-top: 2px solid #303030 !important;
  }
  .truckContainer {
    clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
  }
  .truck {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }
  .truck tr td.front {
    width: 150px !important;
    min-width: 150px !important;
    max-width: 150px !important;
    height: 400px;
    background-color: white;
    border: none;
    padding: 0;
    background-image: url('/static/truck.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto;
  }
  .truck tr td {
    background-color: #D0D0D0;
    border: none;
    padding: 3px;
  }
  .truck tr.rightSide td {
    padding-bottom: 2px !important;
  }
  .truck tr.leftSide td {
    padding-top: 2px !important;
  }
  .tag {
    color: #004d40;
    cursor: pointer;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Reports.vue